package io.github.jangalinski.pages._2014._12._29

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initEasyMysqlSetupWithDockerPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("2014/12/29/EasyMysqlSetupWithDocker.md", FrontMatterElement.Builder { addScalar("title", "Easy MySQL setup with docker"); addScalar("subtitle", "EasyMysql makes your life ... easy"); addScalar("header-img", "/img/about-bg.jpg"); addScalar("date", "2014-12-29"); }))
}

@Page("/2014/12/29/easy-mysql-setup-with-docker")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun EasyMysqlSetupWithDockerPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("While looking for an easy to handle DB setup to develop my ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://github.com/jangalinski/camunda-bpm-dropwizard") {
            org.jetbrains.compose.web.dom.Text("camunda-bpm-dropwizard")
        }
        org.jetbrains.compose.web.dom.Text(" examples (and failing dramatically with h2-server), I chose to give mysql another try. Back in the days when I did CMS and web-programming, I used to love mysql, but over the years in the JEE environment, its become mostly h2 or oracle.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Installing mysql on OSX is simple, but messy. No matter if you choose the pkg installation from mysql.com or use homebrew, your clean mac system gets polluted with lots and lots of files and commands in lots of different locations that you either do not want or do not need. So I made a brutal uninstall (using sudo rm -rf ..., had to run time machine to recover accidentally deleted directories on the way) and went for this \"docker\" everyone keeps talking about.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("After setting everything up for the last 100 minutes, I must say, I am very pleased. Mysql starts up in a docker container, using a sql-dump I provide online to create the database, tables and initial data.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I used ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/nkratzke/EasyMySQL") {
            org.jetbrains.compose.web.dom.Text("EasyMySQL")
        }
        org.jetbrains.compose.web.dom.Text(" by Nane Kratzke (thanks!) and the very well written documentation he provides. So heres what you do:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Homebrew everything: ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("brew install docker boot2docker")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Initialize the VM: ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("boot2docker init")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("... export the DOCKER_* env vars it tells you")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("run ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("docker build -t mysqldb github.com/nkratzke/easymysql")
            }
            org.jetbrains.compose.web.dom.Text(" to build your local image")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("run ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("docker run -d -p 3306:3306 -e user=\"camunda\" -e password=\"camunda\" -e right=\"WRITE\" -e url=\"https://raw.githubusercontent.com/jangalinski/camunda-bpm-dropwizard/master/examples/src/test/resources/camunda_mysql.sql\" mysqldb")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("done")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Of course you should use your own user/pw settings and sql-dump. If you run mine, you get a fresh camunda database with the default users and invoice process instances.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can connect to the DB with the user/pw/db settings you chose and the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("boot2docker ip")
        }
        org.jetbrains.compose.web.dom.Text(" address where your vm is running. And thats it.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Related note: For a very simple DB admin tool, checkout ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://www.adminer.org/de/") {
            org.jetbrains.compose.web.dom.Text("Adminer")
        }
        org.jetbrains.compose.web.dom.Text(" and just run ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("php -S localhost:8000 adminer-4.1.0.php")
        }
        org.jetbrains.compose.web.dom.Text(" on the single file alternative to phpMyAdmin.")
    }
}
